import { useQuery } from '@tanstack/react-query';
import { me } from '@/services/auth';
import { CACHE_TTL } from '@/services/constants';

export const LOGGED_USER_QUERY_KEY = ['user', 'logged-user'];

// O usuário da sessão é o da conta em uso: dentro de conta compartilhada, o titular. Para
// mostrar quem está operando, o `/user/` vai sem o header da impersonação.
export default function useLoggedUser({ enabled = true } = {}) {
  const { data } = useQuery({
    queryKey: LOGGED_USER_QUERY_KEY,
    queryFn: () => me({}, { skipImpersonation: true }),
    enabled,
    staleTime: CACHE_TTL,
  });

  return data ?? null;
}
